'use client';

import { FormEvent, useState } from 'react';
import { ArrowRight, MapPin } from 'lucide-react';
import { useRouter } from 'next/navigation';
import { ui } from '@/lib/site-config';
import type { Locale } from '@/lib/site-types';

export default function PostcodeChecker({ locale, compact = false }: { locale: Locale; compact?: boolean }) {
  const [postcode, setPostcode] = useState('');
  const [error, setError] = useState('');
  const router = useRouter();
  const copy = ui[locale];
  const submit = (event: FormEvent) => {
    event.preventDefault();
    if (!/^\d{4}$/.test(postcode)) {
      setError(locale === 'nl' ? 'Vul een geldige Belgische postcode van vier cijfers in.' : locale === 'fr' ? 'Saisissez un code postal belge valide à quatre chiffres.' : 'Enter a valid four-digit Belgian postcode.');
      return;
    }
    window.dispatchEvent(new CustomEvent('babysitter:postcode_check', { detail: { postcode, locale } }));
    router.push(`/booking-flow?lang=${locale}&postcode=${postcode}`);
  };
  return <form onSubmit={submit} className={`bg-card border border-border rounded-2xl card-shadow ${compact ? 'p-4' : 'p-5 lg:p-6'}`}>
    <label htmlFor={`postcode-${compact ? 'compact' : 'full'}`} className="block text-sm font-bold text-foreground mb-2">{copy.checkPostcode}</label>
    <div className="flex flex-col sm:flex-row gap-2"><div className="relative flex-1"><MapPin size={18} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-primary"/><input id={`postcode-${compact ? 'compact' : 'full'}`} inputMode="numeric" maxLength={4} value={postcode} onChange={(event) => { setPostcode(event.target.value.replace(/\D/g,'')); setError(''); }} placeholder={copy.postcodePlaceholder} className="w-full h-12 pl-11 pr-4 bg-input border border-border rounded-xl outline-none focus:ring-2 focus:ring-primary/30"/></div><button type="submit" className="h-12 px-5 gradient-coral text-white font-bold rounded-xl flex items-center justify-center gap-2 hover:opacity-90">{copy.submit}<ArrowRight size={17}/></button></div>
    <p className={`text-xs mt-2 ${error ? 'text-red-600' : 'text-muted-foreground'}`}>{error || copy.postcodeHelp}</p>
  </form>;
}
